import React from 'react';
import { Gift, ClipboardList, Users, CloudRain, HeartHandshake, Waves, FileText, Brain, FlaskConical, Table2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductDetails() {
  const tomos = [{
    id: 'T1',
    title: 'Evaluación Psicológica Infantil',
    desc: 'Anamnesis por franja etaria, guía de entrevista, escalas de screening y criterios de derivación, listos para tu primera consulta.',
    Icon: ClipboardList,
    tile: 'bg-blue-100',
    iconColor: 'text-blue-600'
  }, {
    id: 'T2',
    title: 'Entrevista Familiar y Clínica',
    desc: 'Guiones de encuadre con padres, protocolo para padres separados y banco de frases para momentos de tensión.',
    Icon: Users,
    tile: 'bg-teal-100',
    iconColor: 'text-teal-600'
  }, {
    id: 'T3',
    title: 'Protocolos de Ansiedad y Depresión',
    desc: 'Secuencias de intervención por franja etaria, con psicoeducación lista para entregar a la familia.',
    Icon: CloudRain,
    tile: 'bg-indigo-100',
    iconColor: 'text-indigo-600'
  }, {
    id: 'T4',
    title: 'Intervención en Trauma y Apego',
    desc: 'Protocolo de estabilización, técnicas de regulación fisiológica y criterios claros de derivación a especialista.',
    Icon: HeartHandshake,
    tile: 'bg-rose-100',
    iconColor: 'text-rose-600'
  }, {
    id: 'T5',
    title: 'Estrategias de Regulación Emocional',
    desc: 'Banco de técnicas por edad para usar en sesión y como tarea en casa.',
    Icon: Waves,
    tile: 'bg-cyan-100',
    iconColor: 'text-cyan-600'
  }, {
    id: 'T6',
    title: 'Modelos de Informe Clínico',
    desc: 'Plantillas para escuela, obra social, padres y ámbito judicial, listas para completar y enviar.',
    Icon: FileText,
    tile: 'bg-violet-100',
    iconColor: 'text-violet-600'
  }];
  const bonuses = [{
    id: 'B1',
    title: 'Desarrollo Neurocognitivo',
    desc: 'Tablas de hitos esperables por edad para apoyo al diagnóstico diferencial.',
    Icon: Brain
  }, {
    id: 'B2',
    title: 'Terapias Basadas en Evidencia',
    desc: 'Síntesis rápida de qué enfoque usar según el cuadro clínico.',
    Icon: FlaskConical
  }, {
    id: 'B3',
    title: 'Planillas Clínicas Exclusivas',
    desc: '12 planillas listas para imprimir: fichas, escalas, seguimiento y cierre de caso.',
    Icon: Table2
  }];
  return <section className="py-10 md:py-20 bg-slate-50 border-y border-slate-100" data-id="element-170">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-14" data-id="element-172">
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-3 md:mb-4" data-id="element-173">
            SISTEMA COMPLETO PARA CONSULTORIO INFANTO-JUVENIL
          </h2>
          <p className="text-base md:text-xl text-blue-600 font-semibold mb-3 md:mb-4" data-id="element-174">
            8 Tomos + 5 Bonos · Consultorio Privado · Marco Legal Argentino
          </p>
          <p className="text-sm md:text-base text-slate-600" data-id="element-175">
            +180 páginas · Plantillas listas para completar · Evaluación ·
            Intervención · Legal · Articulación
            <span className="block mt-2" data-id="element-176">
              Funciona desde tu próxima primera consulta, sin necesidad de
              rediseñar nada.
            </span>
          </p>
        </div>

        {/* Tomos Grid — compact cards with a representative cover per title */}
        <div className="mb-10 md:mb-16" data-id="element-177">
          <h3 className="text-xl md:text-2xl font-bold text-center mb-6 md:mb-8" data-id="element-178">
            CONTENIDO COMPLETO — LOS 6 TOMOS BASE
          </h3>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4" data-id="element-179">
            {tomos.map((tomo, i) => <motion.div initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06
          }} whileHover={{
            y: -3
          }} key={tomo.id} className="bg-white border border-slate-200 rounded-xl overflow-hidden hover:border-blue-300 hover:shadow-md transition-all" data-id="element-180">
                {/* Representative cover (vector = instant load) */}
                <div className={`relative ${tomo.tile} h-20 md:h-24 flex items-center justify-center`} data-id="element-181">
                  <tomo.Icon className={`w-9 h-9 md:w-11 md:h-11 ${tomo.iconColor}`} strokeWidth={1.75} data-id="element-182" />
                  <span className="absolute top-2 left-2 text-[10px] md:text-xs font-bold text-slate-700 bg-white/80 backdrop-blur-sm px-2 py-0.5 rounded-full" data-id="element-183">
                    {tomo.id}
                  </span>
                </div>

                <div className="p-3 md:p-4" data-id="element-184">
                  <h4 className="font-bold text-slate-900 text-sm md:text-base leading-tight mb-1" data-id="element-185">
                    {tomo.title}
                  </h4>
                  <p className="text-slate-500 text-[11px] md:text-xs leading-snug line-clamp-3" data-id="element-186">
                    {tomo.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Bonuses */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-blue-900 rounded-3xl p-6 md:p-10 text-white relative overflow-hidden" data-id="element-187">
          <div className="absolute top-0 right-0 -mt-10 -mr-10 w-48 h-48 md:w-64 md:h-64 bg-blue-800 rounded-full blur-3xl opacity-50" data-id="element-188"></div>

          <div className="relative z-10" data-id="element-189">
            <div className="text-center mb-6 md:mb-8" data-id="element-190">
              <div className="inline-flex items-center justify-center w-11 h-11 md:w-14 md:h-14 bg-amber-500 text-white rounded-full mb-3 shadow-lg shadow-amber-500/30" data-id="element-191">
                <Gift className="w-5 h-5 md:w-7 md:h-7" data-id="element-192" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold mb-1" data-id="element-193">
                INCLUIDOS GRATIS
              </h3>
              <p className="text-blue-200 text-sm md:text-lg" data-id="element-194">
                3 Bonos de Consulta Rápida (Incluidos en ambas ofertas)
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4 mb-6 md:mb-8" data-id="element-195">
              {bonuses.map(bono => <motion.div whileHover={{
              scale: 1.02
            }} key={bono.id} className="bg-white rounded-2xl overflow-hidden text-slate-900 flex sm:block items-stretch" data-id="element-196">
                  {/* Representative cover */}
                  <div className="relative bg-amber-100 w-20 sm:w-full flex-shrink-0 flex items-center justify-center py-0 sm:py-5" data-id="element-197">
                    <bono.Icon className="w-8 h-8 md:w-10 md:h-10 text-amber-600" strokeWidth={1.75} data-id="element-198" />
                    <span className="absolute top-2 left-2 text-[10px] font-bold text-amber-900 bg-white/80 px-1.5 py-0.5 rounded" data-id="element-199">
                      {bono.id}
                    </span>
                  </div>
                  <div className="p-3 md:p-4 min-w-0" data-id="element-200">
                    <h4 className="font-bold text-slate-900 text-sm md:text-base leading-tight mb-0.5" data-id="element-201">
                      {bono.title}
                    </h4>
                    <p className="text-slate-500 text-[11px] md:text-xs leading-snug" data-id="element-202">
                      {bono.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>

            <div className="text-center" data-id="element-203">
              <p className="text-sm md:text-xl font-bold text-amber-400 bg-black/20 inline-block px-4 py-2 md:px-6 md:py-3 rounded-xl" data-id="element-204">
                VALOR TOTAL DE LOS BONOS: $18.000 —{' '}
                <span className="text-white" data-id="element-205">GRATIS HOY</span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}